import {
    UPDATE_TU_ONLINE_STATUS_REQUEST,
    UPDATE_TU_ONLINE_STATUS_SUCCESS,
    UPDATE_TU_ONLINE_STATUS_FAILURE
} from "../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
};

const addUserActivityStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_TU_ONLINE_STATUS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case UPDATE_TU_ONLINE_STATUS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case UPDATE_TU_ONLINE_STATUS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
}
export default addUserActivityStatusReducer